import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NewsletterForm from '../../../components/forms/NewsletterForm';
import { useNewsletterApi } from '../../../hooks/useNewsletterApi';
import { useNavigate, useParams } from 'react-router-dom';
import { NewsletterDTO } from '../../../services/apiClient';

const NewsletterEdit: React.FC = () => {
  const { getById, edit } = useNewsletterApi();
  const [entityData, setEntityData] = useState<NewsletterDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Newsletters', href: '/admin/newsletters' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Newsletter data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/newsletters');
    } catch (error) {
      console.error('Error updating Newsletter:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/newsletters"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Content.Newsletter.Edit"
    >
      {entityData ? (
        <NewsletterForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/newsletters')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default NewsletterEdit;
